export const PAYMENT_PROVIDERS = {
    INVOICE: "invoice",
    NETS: "nets",
    VIPPS: "vipps",
};
export const PAYMENT_PROPERTY = {
    ORDER: {
        INVOICE_ID: "invoiceId",
        PAYMENT_LAST_UPDATED: "paymentLastUpdated",
        NETS_PAYMENT_ID: "netsPaymentId",
        VIPPS_REFERENCE: "vippsReference",
        VIPPS_PSP_REFERENCE: "vippsPspReference",
        VIPPS_FAILURE_REASON: "vippsFailureReason",
    },
    CONTRACT: {
        NEWSLETTER_CONSENT: "newsletterConsent",
        CONTRACT_PENDING_STATUS: "contractPendingStatus",
        PENDING_SNAPSHOT: "pending.snapshot",
        PENDING_NON_MATCHING_FIELDS: "pending.nonMatchingFields",
        PERIODS_TO_SKIP: "periodsToSkip",
    },
    SHARED: {
        IDENTIFIER: "identifier",
        CHARGE_ID: "chargeId",
        NETS_UNSCHEDULED_SUBSCRIPTION_ID: "netsUnscheduledSubscriptionId",
    },
};
export const CONTRACT_PENDING_STATUS = {
    USER_VERIFICATION_NEEDED: "user-verification-needed",
};
export const INVOICE_PAYMENT_STATUS_PIPELINE = {
    NAME: "Faktura betalingsstatus",
    STAGES: {
        UNKNOWN: "Unknown",
        OPEN: "Open",
        CLOSED: "Closed",
        FIRST_REMINDER: "FirstReminder",
        SECOND_REMINDER: "SecondReminder",
        THIRD_REMINDER: "ThirdReminder",
        DEBT_COLLECTION: "DebtCollection",
    },
};
